<template>
  <div>
    <HeaderComponent
      :pageContent="pageHeader"
      @change_language="handleHeaderClick"
    ></HeaderComponent>
    <div class="container py-4">
      <div class="row">
        <div class="col-md-12">
          <h2>{{ pageContent.title }}</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p>
            {{ pageContent.description }}
          </p>
        </div>
      </div>
      <br /><br />
      <div class="row">
        <div class="col-md-4">
          <a
            href="javascript:void(0);"
            @click="scrollToSection('local-community')"
          >
            <img
              src="assets/images/community/Filipino-Community/1.1.png"
              alt=""
              class="img-fluid d-block mx-auto mb-3"
            />
            <h4 class="text-center">{{ pageContent.localCommunity }}</h4>
          </a>
        </div>
        <div class="col-md-4">
          <a
            href="javascript:void(0);"
            @click="scrollToSection('community-health')"
          >
            <img
              src="assets/images/community/Health-Services/1.2.png"
              alt=""
              class="img-fluid d-block mx-auto mb-3"
            />
            <h4 class="text-center">{{ pageContent.healthCenters }}</h4>
          </a>
        </div>
        <div class="col-md-4">
          <a href="javascript:void(0);" @click="scrollToSection('volunteer')">
            <img
              src="assets/images/community/Volunteer/1.3.png"
              alt=""
              class="img-fluid d-block mx-auto mb-3"
            />
            <h4 class="text-center">{{ pageContent.volunteer }}</h4>
          </a>
        </div>
      </div>
    </div>
    <br /><br />
    <div class="container-fluid py-4" style="background: #f0f1f5">
      <br /><br />
      <div class="row" id="local-community">
        <div class="col-md-12">
          <h1>
            {{ pageContent.localCommunityTitle }}<br />{{
              pageContent.localCommunityTitle2
            }}
          </h1>
          <br />
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-4">
          <img
            src="assets/images/community/Filipino-Community/5.png"
            alt=""
            class="img-fluid"
          />
        </div>
        <div class="col-md-8">
          <h4>{{ pageContent.pcfiTitle }}</h4>
          <p>
            {{ pageContent.pcfiDesc }}
          </p>
          <br />
          <h4 style="font-weight: 400">{{ pageContent.projectsEvents }}</h4>
          <br />
          <div class="row">
            <div class="col-md-4">
              <img
                src="assets/images/community/Filipino-Community/1.png"
                alt=""
                class="img-fluid"
              />
              <p>
                <b>{{ pageContent.bahayTitle }}</b>
              </p>
              <p>
                {{ pageContent.bahayDesc }}
              </p>
            </div>
            <div class="col-md-4">
              <img
                src="assets/images/community/Filipino-Community/2.png"
                alt=""
                class="img-fluid"
              />
              <p>
                <b>{{ pageContent.barrioTitle }}</b>
              </p>
              <p>
                {{ pageContent.barrioDesc }}
              </p>
            </div>
            <div class="col-md-4">
              <img
                src="assets/images/community/Filipino-Community/3.png"
                alt=""
                class="img-fluid"
              />
              <p>
                <b>{{ pageContent.philfestTitle }}</b>
              </p>
              <p>
                {{ pageContent.philfestDesc }}
              </p>
            </div>
            <br />
            <a href="https://pcfitampa.org/" target="_blank">
              <img
                src="assets/images/community/1.png"
                class="img-fluid d-block ms-auto"
                style="height: 50px; width: auto"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
      <br /><br /><br />

      <div class="row">
        <div class="col-md-4">
          <img
            src="assets/images/hispanic/Hispanic.png"
            alt=""
            class="img-fluid"
          />
        </div>
        <div class="col-md-8">
          <h4>Hispanic Services Council (HSC)</h4>
          <p>
            A nonprofit organization dedicated to increasing access and
            opportunities for Latinos in areas such as education, health, and
            civic engagement. They offer various volunteer opportunities,
            including educational support for children.
          </p>
          <br />
          <h4 style="font-weight: 400">PROJECTS AND EVENTS</h4>
          <br />
          <div class="row">
            <div class="col-md-4">
              <img
                src="assets/images/hispanic/1.png"
                alt=""
                class="img-fluid"
              />
              <h5 class="mt-2" style="font-weight: 400">HOMEWORK HELPER</h5>
              <p>
                Students from 1st Grade to 8th Grade will be assigned a volunteer who
                assists them with their homework. This program is for families who struggle academically due to
                language barrier and not
                comprehension in general.
              </p>
              <br />
            </div>
            <div class="col-md-4">
              <img
                src="assets/images/hispanic/2.png"
                alt=""
                class="img-fluid"
              />
              <h5 class="mt-2" style="font-weight: 400">ESOL PROGRAM</h5>
              <p>

                This program is intended as an add on at the weekly La Red workshop. A volunteer will be teaching a
                curriculum to help immigrant
                children to learn English and prepare them for school.
              </p>
              <br />
            </div>
            <div class="col-md-4">
              <img
                src="assets/images/hispanic/3.png"
                alt=""
                class="img-fluid"
              />
              <h5 class="mt-2" style="font-weight: 400">DIGITAL LITERACY</h5>
              <p>
                A program where adults are paired with a tech savy volunteer. They will be taught how to navigate
                important applications such as Zoom, Black Board, Canvas and others. These programs are needed to
                understand for their children's academic success.
              </p>
              <br />
            </div>
            <a href="https://pcfitampa.org/" target="_blank">
              <img
                src="assets/images/community/1.png"
                class="img-fluid d-block ms-auto mt-3"
                style="height: 50px; width: auto; margin-top: 50px"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
      <br /><br /><br />
      <div class="row" id="community-health">
        <div class="col-md-12">
          <h1>{{ pageContent.healthServices }}</h1>
          <br />
        </div>
        <br />
        <div class="col-md-4">
          <img
            src="assets/images/community/Health-Services/4.png"
            alt=""
            class="img-fluid"
          />
        </div>
        <div class="col-md-8">
          <h4>{{ pageContent.baycareTitle }}</h4>
          <p>
            {{ pageContent.baycareDesc }}
          </p>
          <br />
          <h4 style="font-weight: 400">{{ pageContent.services }}</h4>
          <br />
          <div class="row">
            <div class="col-md-4">
              <img
                src="assets/images/community/Health-Services/1.png"
                alt=""
                class="img-fluid"
              />
              <p>
                <b>{{ pageContent.screenings }} </b>
              </p>
            </div>
            <div class="col-md-4">
              <img
                src="assets/images/community/Health-Services/2.png"
                alt=""
                class="img-fluid"
              />
              <p>
                <b>{{ pageContent.immunizations }}</b>
              </p>
            </div>
            <div class="col-md-4">
              <img
                src="assets/images/community/Health-Services/3.png"
                alt=""
                class="img-fluid"
              />
              <p>
                <b>{{ pageContent.educationWorkshops }}</b>
              </p>
              <br />
            </div>
            <a href="">
              <img
                src="assets/images/community/2.png"
                class="img-fluid d-block ms-auto"
                style="height: 50px; width: auto"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
      <br /><br /><br />
      <div class="row">
        <br />
        <div class="col-md-4">
          <img
            src="assets/images/community/Health-Services/5.png"
            alt=""
            class="img-fluid"
          />
        </div>
        <div class="col-md-8">
          <h4>{{ pageContent.psychologyTitle }}</h4>
          <p>
            {{ pageContent.psychologyDesc }}
          </p>
          <br />
          <h4 style="font-weight: 400">{{ pageContent.services }}</h4>
          <br />
          <div class="row">
            <div class="col-md-4">
              <img
                src="assets/images/community/Health-Services/6.png"
                alt=""
                class="img-fluid"
              />
              <p>
                <b>{{ pageContent.individualTherapy }}</b>
              </p>
            </div>
            <div class="col-md-4">
              <img
                src="assets/images/community/Health-Services/7.png"
                alt=""
                class="img-fluid"
              />
              <p>
                <b>{{ pageContent.stressManagement }}</b>
              </p>
            </div>
            <div class="col-md-4">
              <img
                src="assets/images/community/Health-Services/8.png"
                alt=""
                class="img-fluid"
              />
              <p>
                <b>{{ pageContent.burnoutPrevention }}</b>
              </p>
              <br />
            </div>
            <a
              href="https://www.psychologyhouse.org/tampa-teachers-mental-healthcare"
              target="_blank"
            >
              <img
                src="assets/images/community/1.png"
                class="img-fluid d-block ms-auto mt-3"
                style="height: 50px; width: auto; margin-top: 50px"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
      <br /><br /><br />
      <div class="row" id="volunteer">
        <div class="col-md-12">
          <h1>{{ pageContent.volunteerTitle1 }}</h1>
          <br />
        </div>
        <br />
        <div class="col-md-4">
          <img
            src="assets/images/community/Volunteer/4.png"
            alt=""
            class="img-fluid"
          />
        </div>
        <div class="col-md-8">
          <br />
          <h4>{{ pageContent.tampaVolunteersTitle }}</h4>
          <br />

          <p>
            {{ pageContent.tampaVolunteersDesc }}
          </p>
          <br />
          <a href="https://tampavolunteers.com/" target="_blank">
            <img
              src="assets/images/community/1.png"
              class="img-fluid d-block mt-3"
              style="height: 50px; width: auto; margin-top: 50px"
              alt=""
            />
          </a>
        </div>
      </div>
      <br /><br /><br />
      <div class="row">
        <div class="col-md-12">
          <!-- <h1>{{ pageContent.volunteerTitle2 }}</h1> -->
          <!-- <br /> -->
        </div>
        <br />
        <div class="col-md-4">
          <img
            src="assets/images/community/Volunteer/5.png"
            alt=""
            class="img-fluid"
          />
        </div>
        <div class="col-md-8">
          <br />
          <h4>VolunteerMatch Tampa Bay
          </h4>
          <br />
          <p>
            VolunteerMatch is a nationwide platform that connects individuals with local volunteer opportunities. By
            entering your location and interests, you can find a variety of causes in the Tampa Bay area that need
            support.

          </p>
          <br />
          <a href="https://www.volunteermatch.org/search/?l=Tampa,%20FL,%20USA" target="_blank">
            <img src="assets/images/community/1.png" class="img-fluid d-block mt-3"
              style="height: 50px; width: auto; margin-top: 50px" alt="" />
          </a>
        </div>
      </div>
      <br /><br /><br />

      <br /><br /><br />
    </div>

    <FooterComponent :pageContent="pageFooter"></FooterComponent>
  </div>
</template>
<script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import globalMixins from "@/plugins/globalMixins";

export default {
  name: "AboutUs",
  components: {
    HeaderComponent,
    FooterComponent,
  },
  data() {
    return {
      pageContent: [],
      pageHeader: [],
      pageFooter: [],
    };
  },
  mounted() {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      this.language = storedLanguage;
    }
    this.convertLanguage();
  },
  methods: {
    goToRegister() {
      window.location = "/user/register";
    },
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        const headerOffset = 80; // Adjust this value based on your header height
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    },
    handleHeaderClick() {
      this.convertLanguage();
    },
    async convertLanguage() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        this.language = storedLanguage;
      }

      let lang = this.language;
      if (lang === "us") {
        lang = "en";
      }

      console.log("Updated content:", lang);

      const converted = globalMixins.community[lang];

      const pageHeader = globalMixins.pageHeader[lang];

      const pageFooter = globalMixins.pageFooter[lang];

      if (converted) {
        this.pageContent = {
          ...this.pageContent,
          ...converted,
        };

        this.pageHeader = {
          ...this.pageHeader,
          ...pageHeader,
        };
        this.pageFooter = {
          ...this.pageFooter,
          ...pageFooter,
        };
      }
    },
  },
};
</script>
